module.exports = __webpack_public_path__ + "static/media/check_status_img.4d413533.png";